import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Box, useMediaQuery } from '@mui/material';
import { Container, Footer} from 'components';
import Header from 'components/Header/Header'
import ReadOnlyNotice from 'modules/Admin/ReadOnlyNotice'

const Page = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const matches = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const location = useLocation();
  const navigate = useNavigate();
  const error = new URLSearchParams(location.search).get('error');

  useEffect(() => {
    // LandingPage handles the Facebook email error separately.
    if (!error || error === 'FACEBOOK_EMAIL_NOT_FOUND') return;

    enqueueSnackbar(`We could not log you in. \n Reason: ${error}`, {
      variant: 'error',
      style: { whiteSpace: 'pre-line' },
    });

    const searchParams = new URLSearchParams(location.search);
    searchParams.delete('error');
    const search = searchParams.toString();
    navigate({
      pathname: location.pathname,
      search: search ? `?${search}` : '',
      hash: location.hash,
    }, { replace: true, state: location.state });
  }, [enqueueSnackbar, error, location.hash, location.pathname, location.search, location.state, navigate]);

  return (
    <>
      <Header />
      <Container>
        <Box mt={matches ? 15 : 3} minHeight="50vh">
          <ReadOnlyNotice />
          {children}
        </Box>
        <Footer />
      </Container>
    </>
  );
};

export default Page;
